<template>
    <div class="myVideo">
      <video controls>
        <source :src="videoUrl" type="video/mp4">
        <source :src="videoUrl" type="video/ogg">
        Your browser does not support HTML5 video.
      </video>
    </div>
</template>

<script>
    export default {
      name: "myVideo",
      props:{
          videoUrl:{
            require:true,
            type: String
          }
      }
    }
</script>

<style scoped>
  .myVideo{
    margin:8px;
  }


  video{
    width:100%;
    max-width: 300px;
  }
</style>
